/* eslint-disable */
/* **IMPORTANT** font must be escaped single quoted because of white space in font family name. */
export default {
  _5x5_Pixel: '\'5x5 Pixel\'',
}